import { render, staticRenderFns } from "./RedPacketUpdatePane.vue?vue&type=template&id=56541d64&scoped=true"
import script from "./RedPacketUpdatePane.vue?vue&type=script&lang=js"
export * from "./RedPacketUpdatePane.vue?vue&type=script&lang=js"
import style0 from "./RedPacketUpdatePane.vue?vue&type=style&index=0&id=56541d64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56541d64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56541d64')) {
      api.createRecord('56541d64', component.options)
    } else {
      api.reload('56541d64', component.options)
    }
    module.hot.accept("./RedPacketUpdatePane.vue?vue&type=template&id=56541d64&scoped=true", function () {
      api.rerender('56541d64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketUpdatePane.vue"
export default component.exports